module.exports = __webpack_public_path__ + "static/App_Store-ebc1cc2434f1c75ccdb7fe7b2c972aaa.png";